import { useQuestionizerStore } from "../types/state.ts";
import Toggle from "./toggle.tsx";

export default function InputWohngebaeude (props: {id: number, label: string, icon: string, icon_active?:string, onBlur?: ()=>void}){
  const wohngebaeude = useQuestionizerStore((state) => state.wohngebaeude);
  const setWohngebaeude = useQuestionizerStore((state) => state.setWohngebaeude);
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const label = useQuestionizerStore((state) => state.E('input-wohngebaeude'));


  return <div>
    <div className="flex flex-row justify-center">
        <Toggle id={props.id.toString()} label={props.label || label} icon={props.icon} icon_active={props.icon_active} value={wohngebaeude || false} onBlur={props.onBlur} onChange={(_)=>{
          setWohngebaeude(!wohngebaeude);
          updateValidation();
        }}/>
    </div>
  </div>
}